<script>
  import Table from "../../components/table/Table.svelte";
  import TableHeader from "../../components/table/TableHeader.svelte";
  import TableHeaderCell from "../../components/table/TableHeaderCell.svelte";
  import TableBody from "../../components/table/TableBody.svelte";
  import TableCell from "../../components/table/TableCell.svelte";
  import Radio from "../../components/input/Radio.svelte";
  import TableRow from "../../components/table/TableRow.svelte";
  import OpenInNewIconButton from "../../components/IconButtons/OpenInNewIconButton.svelte";
  import { getAutoMpsProjectContext } from "../AutoMpsProjectContext.js";
  import { constructImportsTableHeaders } from "./ImportsTableUtils.js";

  export let dataType
  export let selectedRowId

  export let headers = constructImportsTableHeaders()
  export let rows

  const ctx = getAutoMpsProjectContext()
</script>

<Table>
  <TableHeader>
    {#each headers as header}
      {#if header.key.startsWith("__")}
        {#if header.key === "__select_radio"}
          <TableHeaderCell>選択</TableHeaderCell>
        {/if}
        {#if header.key === "__view_import"}
          <TableHeaderCell>見る</TableHeaderCell>
        {/if}
      {:else}
        <TableHeaderCell>{header.headerTitle}</TableHeaderCell>
      {/if}
    {/each}
  </TableHeader>
  <TableBody>
    {#each rows as row}
      <TableRow>
        {#each headers as header}
          {#if header.key.startsWith("__")}
            {#if header.key === "__select_radio"}
              <TableCell>
                <Radio bind:group={selectedRowId} value={row.id} size="1rem"/>
              </TableCell>
            {/if}
            {#if header.key === "__view_import"}
              <TableCell>
                <a href={`/auto-mps/projects/${$ctx.projectId}/imports/${dataType}/${row.id}`} target="_blank">
                  <OpenInNewIconButton/>
                </a>
              </TableCell>
            {/if}
          {:else}
            <TableCell>
              {row[header.key]}
            </TableCell>
          {/if}
        {/each}
      </TableRow>
    {:else}
      <TableRow>
        <TableCell colspan={headers.length}>インポートされたデータがありません。</TableCell>
      </TableRow>
    {/each}
  </TableBody>
</Table>
